import { useLocalization } from "@fluent/react";
import { Row, useBreakpoints } from "@narmi/design_system";
import { catcat as cc } from "cerulean";
import { useUserFeatures } from "../../contexts/UserFeaturesContext";
import styles from "./CreateBulk.module.scss";

type BulkTotalsDisplayProps = {
  collectTotalFormatted: string;
  sendTotalFormatted: string;
  netTotalFormattedWithSign: string;
};

const BulkTotalsDisplay = ({
  collectTotalFormatted,
  sendTotalFormatted,
  netTotalFormattedWithSign,
}: BulkTotalsDisplayProps) => {
  const { l10n } = useLocalization();
  const { s } = useBreakpoints();
  const { ach_payments_collect: achPaymentsCollectFeature } = useUserFeatures();

  return (
    <div className="margin--top--xl margin--bottom--xl">
      {achPaymentsCollectFeature ? (
        <div className={cc("margin--bottom--s", styles.totalContainer)}>
          <Row>
            <Row.Item>
              <div className={styles.sendingCollectingContainer}>
                {`${l10n.getString("label-collecting")}: `}
                <span className="fontColor--success fontWeight--semibold">
                  {collectTotalFormatted}
                  <span className="margin--left--xxs narmi-icon-arrow-left" />
                </span>
              </div>
              <div
                className={cc(
                  { "margin--left--l": s },
                  styles.sendingCollectingContainer
                )}
              >
                {`${l10n.getString("label-sending")}: `}
                <span className="fontColor--error fontWeight--semibold">
                  {sendTotalFormatted}
                  <span className="margin--left--xxs narmi-icon-arrow-right" />
                </span>
              </div>
            </Row.Item>

            <Row.Item shrink>
              {`${l10n.getString("label-net-total")}: `}
              <span className="fontWeight--semibold">
                {netTotalFormattedWithSign}
              </span>
            </Row.Item>
          </Row>
        </div>
      ) : null}
      <Row justifyContent="end">
        {!achPaymentsCollectFeature ? (
          <Row.Item shrink>
            <div className={styles.totalContainer}>
              <span className="fontWeight--semibold">
                {`${l10n.getString("label-total")}: `}
              </span>
              {sendTotalFormatted}
            </div>
          </Row.Item>
        ) : null}
      </Row>
    </div>
  );
};

export default BulkTotalsDisplay;
